import { createWorkOrder } from '#/graphql/mutations';
import type { CreateWorkOrderMutation, WorkOrderDetails, WorkOrderInput } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { SubmitWorkOrder } from '../utils/types';

const q = gql(createWorkOrder);

const useWorkOrderCreate = () => {
  const [mutation, result] = useMutation<CreateWorkOrderMutation>(q);

  const createWorkOrder = useCallback(
    async (workOrder: WorkOrderDetails & WorkOrderInput) => {
      const {
        __typename,
        id,
        createdAt,
        displayNumber,
        createdBy,
        updatedAt,
        updatedBy,
        tenant,
        number,
        user,
        location,
        assetLocation,
        asset,
        assignedTo,
        closedBy,
        actualCostValue,
        estimatedCostValue,
        estimatedEffort,
        duration,
        assetModel,
        ...workOrderInput
      } = workOrder;

      const response = await mutation({
        variables: {
          data: workOrderInput,
        },
      });
      return response.data?.createWorkOrder ?? undefined;
    },
    [mutation],
  ) as SubmitWorkOrder;

  return { createWorkOrder, result };
};

export default useWorkOrderCreate;
